module.exports = {
	"Search the video": "搜索視頻",
	"Explore": "探索",
	"Print": "打印",
	"Download": "下載",
	"Share": "分享",
	"Settings": "設置",
	"Language": "語言",
	"Interface Language": "界面語言",
	"Transcript / Captions Language": "副本/字幕語言",
	"Transcript Language": "副本語言",
	"Captions Language": "字幕語言",
	"Show Transcript": "顯示副本",
	"Show Captions": "顯示字幕",
	"Show Heatmap": "顯示熱圖",
	"Show Speakers in Transcript": "在副本中顯示說話者",
	"Keyword": "關鍵詞",
	"Keywords": "關鍵字",
	"Topic": "主題",
	"Topics": "主題",
	"Speaker": "說話者",
	"Speakers": "說話者",
	"Transcript": "副本",
	"Previous": "上一個",
	"Next": "下一個",
	"Clear": "清除",
	"No results found": "未找到結果",
	"try another search or explore": "請嘗試其它搜索或瀏覽",
	"Share Search": "分享搜索",
	"Share Time": "分享時間",
	"There is no transcript available in the selected language.": "所選擇的語言並無可用的副本。",
	"Show {{count}} more": "再顯示{{count}}个",
	"Show {{count}} more_plural": "再顯示{{count}}个"
};


//////////////////
// WEBPACK FOOTER
// ./locale/zh-tw.json
// module id = ./locale/zh-tw.json
// module chunks = 0 1